module.exports = __webpack_public_path__ + "static/media/shadow-walk.d49d1a07.png";